import Popover from "@/components/popover/popover";
import Button from "@/components/button/button";
import Icon from "@/components/icon/icon";
import { useTranslation } from "@/lib/i18n";

import styles from "./marker-parameter-time-series-warning.module.css";

type MarkerParameterTimeSeriesWarningProps = {
  onFix: () => void;
};

export function MarkerParameterTimeSeriesWarning({
  onFix,
}: MarkerParameterTimeSeriesWarningProps) {
  const { t } = useTranslation();

  return (
    <Popover
      nested
      rootProps={{ positioning: { placement: "top" } }}
      trigger={
        <button
          type="button"
          className={styles.warningTrigger}
          aria-label={t(
            "admin.widgets.fields.observations_map.marker_designs.missing_time_series_aria",
          )}
        >
          <Icon name="triangle-alert" size={16} />
        </button>
      }
    >
      <div className={styles.warningPopover}>
        <p className={styles.warningText}>
          {t("admin.widgets.fields.observations_map.marker_designs.missing_time_series")}
        </p>
        <Button type="button" variant="solid" onClick={onFix}>
          {t("admin.widgets.fields.observations_map.marker_designs.fix_time_series")}
        </Button>
      </div>
    </Popover>
  );
}
